import React from 'react';
import { PropTypes } from 'prop-types';
import { useField } from 'formik';
import classnames from 'classnames';

import { Instructions } from '@styled';
import Asterisk from '../Asterisk/index';
import Checkbox from '../Checkbox';

// https://formik.org/docs/examples/checkboxes
// This can be used for separate checkboxes under the same label - different names, no values
// or group checkboxes with the same name, different values
const Checkboxes = ({ label, ...props }) => {
    const [field, meta] = useField(props);
    const { options, required, instructions } = props;

    const hasError = meta.touched && meta.error;
    const groupClasses = classnames('form-group');

    return (
        <div className={groupClasses}>
            <h5 className="mb-3">
                {label} {required && <Asterisk />}
                {instructions && <Instructions>{instructions}</Instructions>}
            </h5>
            {options.map((o, i) => (
                <Checkbox name={o.name || props.name} label={o.label} key={`check-${i}`} value={o.value} />
            ))}
            {hasError ? <div className="error-msg">{meta.error}</div> : null}
        </div>
    );
};

Checkboxes.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string,
    options: PropTypes.array,
    required: PropTypes.bool,
    instructions: PropTypes.string,
};

export default Checkboxes;
